/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationRequest,
  CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationResponse,
  CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostPathParams,
  CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostQueryParams,
  CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostHeaderParams,
  CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPost422,
} from '../../types/CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPost.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const createReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationKey = () => [{ url: '/api/v1/reply_schedule/thread/{thread_id}' }] as const

export type CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationKey = ReturnType<
  typeof createReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationKey
>

/**
 * @summary Create Reply Schedule
 * {@link /api/v1/reply_schedule/thread/:thread_id}
 */
export async function createReplyScheduleApiV1ReplyScheduleThreadThreadIdPost(
  thread_id: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostPathParams['thread_id'],
  data: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationRequest,
  params?: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostQueryParams,
  headers?: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostHeaderParams,
  config: Partial<RequestConfig<CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const res = await request<
    CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationResponse,
    ResponseErrorConfig<CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPost422>,
    CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationRequest
  >({
    method: 'POST',
    url: `/api/v1/reply_schedule/thread/${thread_id}`,
    params,
    data: requestData,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

/**
 * @summary Create Reply Schedule
 * {@link /api/v1/reply_schedule/thread/:thread_id}
 */
export function useCreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPost<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationResponse,
      ResponseErrorConfig<CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPost422>,
      {
        thread_id: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostPathParams['thread_id']
        data: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationRequest
        params?: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostQueryParams
        headers?: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostHeaderParams
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationRequest>> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationKey()

  return useMutation<
    CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationResponse,
    ResponseErrorConfig<CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPost422>,
    {
      thread_id: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostPathParams['thread_id']
      data: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostMutationRequest
      params?: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostQueryParams
      headers?: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostHeaderParams
    },
    TContext
  >(
    {
      mutationFn: async ({ thread_id, data, params, headers }) => {
        return createReplyScheduleApiV1ReplyScheduleThreadThreadIdPost(thread_id, data, params, headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}